import { render, staticRenderFns } from "./dingBasicInfo.vue?vue&type=template&id=373cfa78&scoped=true"
import script from "./dingBasicInfo.vue?vue&type=script&lang=js"
export * from "./dingBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373cfa78",
  null
  
)

export default component.exports